import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

import CadastroProcedimentoValor from "./CadastroProcedimentoValor";
import DataUtil from "../../../actions/data";

class CadastroProcedimento extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    if (this.props.match.params.id) {
      this.state.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.incluirValor = this.incluirValor.bind(this);
    this.alterarValor = this.alterarValor.bind(this);
    this.removerValor = this.removerValor.bind(this);
  }
  getInitialState() {
    return {
      id: 0,
      codigo: "",
      unidade: 1,
      valorReceber: "0.00",
      descricao: "",
      tipo: 1,
      dataVigencia: DataUtil.primeiroDiaMes(),
      grupoPaciente: false,
      ataReuniao: false,
      usaQuantidade: false,
      inativo: false,
      valores: []
    };
  }

  // Hack para atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    this.setState(this.getInitialState());
  }

  incluirValor(colecao) {
    let lista = this.state.valores.concat(colecao);
    this.setState({ valores: lista });
  }

  alterarValor(valor, i) {
    let lista = this.state.valores;
    lista[i] = valor;
    this.setState({ valores: lista });
  }

  removerValor(idxRemover) {
    let lista = this.state.valores.filter(
      function (e, idx) {
        return idx !== idxRemover;
      }
    );
    this.setState({ valores: lista });
  }

  componentDidMount() {
    UI.inputHelpers();

    // Verifica se vem de uma rota com id
    let id = parseInt(this.state.id);
    if (id !== 0) {
      UI.loader("show", "Um momento...");
      API.get("/procedimentos/" + id).then(function (json) {
        json.data.valorReceber = json.data.valorReceber.toFixed(2);
        var i;
        for (i = 0; i < json.data.valores.length; i++) {
          json.data.valores[i].valorPagar = json.data.valores[i].valorPagar.toFixed(2);
        }
        if (!DataUtil.validarData(json.data.dataVigencia)) json.data.dataVigencia = "";
        this.setState(json.data);
        UI.loader("hide");
      }.bind(this))
        .catch(function (json) {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // Validação dos campos (temporario)
    let data = this.state;
    if (data.codigo.length < 3) {
      UI.alert(false, "Código é obrigatório.");
      return;
    }
    else if (!DataUtil.validarData(data.dataVigencia)) {
      UI.alert(false, "Preencha corretamente a data de vigência.");
      return;
    }
    else if (parseFloat(data.valor) === 0) {
      UI.alert(false, "O valor à Receber não foi informado.");
      return;
    }
    else if (data.descricao.length < 3) {
      UI.alert(false, "Dê uma descrição à esse procedimento.");
      return;
    }

    UI.confirm("Atenção", "Todos os lançamentos apartir de " + data.dataVigencia +
      " terão os valores atualizados. \nTem certeza que deseja salvar?")
      .then((value) => {
        if (!value) return;
        // Chamada da API
        UI.loader("show", "Um momento...");
        API.post("/procedimentos", data)
          .then(function (json) {
            if (!DataUtil.validarData(json.data.dataVigencia)) json.data.dataVigencia = "";
            this.setState(json.data);
            UI.alert(json.success, json.message);
            UI.loader("hide");
          }.bind(this))
          .catch(function (json) {
            UI.alert(false, json.message);
            UI.loader("hide");
          });
      })
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChecked(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-md-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    {this.state.id === 0 && <h4 className="card-title">NOVO PROCEDIMENTO</h4>}
                    {this.state.id !== 0 && <h4 className="card-title">CADASTRO PROCEDIMENTO #{this.state.id}</h4>}
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/procedimento/auditoria/" + this.state.id) }}
                      className="btn btn-info">
                      <i className="fa fa-clock-o"></i>&nbsp;Auditoria
                    </button>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Código *</label>
                    <input
                      autoFocus
                      placeholder="CÓDIGO"
                      name="codigo"
                      type="text"
                      className="form-control"
                      value={this.state.codigo}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Data de Vigência</label>
                    <InputMask
                      placeholder="DATA DE VIGÊNCIA"
                      name="dataVigencia"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.dataVigencia}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Valor Receber (R$) *</label>
                    <input
                      type="number"
                      step="any"
                      name="valorReceber"
                      value={this.state.valorReceber}
                      onChange={this.handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Unidade *</label>
                    <select
                      name="unidade"
                      className="form-control"
                      value={this.state.unidade}
                      onChange={this.handleChange}
                    >
                      <option value={1}>HORA</option>
                      <option value={2}>LANÇAMENTO</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label>TIpo *</label>
                    <select
                      name="tipo"
                      className="form-control"
                      value={this.state.tipo}
                      onChange={this.handleChange}
                    >
                      <option value={1}>ATENDIMENTO</option>
                      <option value={2}>ATIVIDADE / REUNIÃO</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Descrição *</label>
                    <textarea
                      rows="6"
                      placeholder="DESCRIÇÃO"
                      name="descricao"
                      className="form-control"
                      value={this.state.descricao}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-check form-check-info">
                      <label className="form-check-label">
                        <input
                          name="grupoPaciente"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.grupoPaciente}
                          onChange={this.handleChecked}
                        />
                        Grupo de Pacientes?
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-check form-check-info">
                      <label className="form-check-label">
                        <input
                          name="ataReuniao"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.ataReuniao}
                          onChange={this.handleChecked}
                        />
                        Imprime nº ATA de reunião?
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-check form-check-info">
                      <label className="form-check-label">
                        <input
                          name="usaQuantidade"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.usaQuantidade}
                          onChange={this.handleChecked}
                        />
                        Usa Quantidade?
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-check form-check-danger">
                      <label className="form-check-label">
                        <input
                          name="inativo"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.inativo}
                          onChange={this.handleChecked}
                        />
                        Inativo
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CadastroProcedimentoValor
            valores={this.state.valores}
            onIncluirValor={this.incluirValor}
            onAlterarValor={this.alterarValor}
            onRemoverValor={this.removerValor}
          />
        </div>
      </form>
    );
  }
}

export default withRouter(CadastroProcedimento);
